export default "__VITE_PUBLIC_ASSET__8a70318e__"